import React, { FC } from 'react';
import styled from 'styled-components';
import { Theme, Svg } from 'styled';
import { Color } from 'styled/theme/colors';
import { svgHoverColor } from 'styled/utils';

type Props = {
  className?: string;
  primaryColor?: Color;
  secondaryColor?: Color;
};

const LikeIcon: FC<Props> = ({
  className = '',
  primaryColor = 'white',
  secondaryColor = 'black',
}) => (
  <Svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    className={className}
    fill="transparent"
  >
    <desc>Like Icon.</desc>
    <circle cx="20" cy="20" r="20" fill={Theme.colors[primaryColor]} />
    <path
      fill={Theme.colors[secondaryColor]}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5419 15.0527C22.7557 15.3351 22.8826 15.6871 22.8826 16.0687V16.8151V18.3151H24.3826H26.0613C26.3909 18.3114 26.7054 18.4526 26.9217 18.7013C27.1379 18.9499 27.234 19.281 27.1846 19.6069L26.4096 24.6614C26.3256 25.2152 25.8464 25.6225 25.2863 25.6162H20.4512H18.9512V24.1162V19.4384L21.1977 14.3838C21.6939 14.3838 22.14 14.5983 22.4484 14.9396C22.4811 14.9759 22.5124 15.0136 22.5419 15.0527ZM25.2796 27.1162H18.9512C18.1228 27.1162 17.4512 26.4446 17.4512 25.6162V19.4384C17.4512 19.2285 17.4953 19.021 17.5805 18.8292L19.827 13.7746C20.0677 13.2329 20.6049 12.8838 21.1977 12.8838C22.9567 12.8838 24.3826 14.3097 24.3826 16.0687V16.8151H26.0546C26.8205 16.8095 27.5508 17.1388 28.0536 17.717C28.5586 18.2978 28.7831 19.071 28.6676 19.832L28.6673 19.8342L27.8926 24.8864C27.8925 24.8868 27.8925 24.8873 27.8924 24.8878C27.6962 26.177 26.5828 27.1259 25.2796 27.1162ZM17.7769 25.6163C17.7769 26.4447 17.1053 27.1163 16.2769 27.1163H14.592C13.1432 27.1163 11.9688 25.9418 11.9688 24.4931V20.5617C11.9688 19.1129 13.1432 17.9385 14.592 17.9385H16.2769C17.1053 17.9385 17.7769 18.61 17.7769 19.4385V25.6163ZM14.7769 25.6163H16.2769V24.1163V20.9385V19.4385H14.7769H14.592C13.9716 19.4385 13.4688 19.9414 13.4688 20.5617V24.4931C13.4688 25.1134 13.9716 25.6163 14.592 25.6163H14.7769Z"
    />
  </Svg>
);

export default styled(LikeIcon)`
  ${svgHoverColor('blue-darker')}
`;
